// this is an autogenerated file from DesignSystem/TimegridOverrideTemplate/ChairTemplateSelect/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TimegridOverrideTemplate_ChairTemplateSelect($location_id: uuid!) {
  vaxiom_appointment_templates(
    where: {
      deleted: { _eq: false }
      organization: { _id: { _eq: $location_id } }
    }
    order_by: { full_name_computed: asc }
  ) {
    id
    full_name_computed
    color_id_computed
    duration
    appointment_type {
      id
      _id
      emergency
    }
  }
}

`